<template>
    <section class="dashboard-users-card">
        <div v-if="loading" class="loader">
            <ui-load-indicator bg-color="#C9C9E8" color="#0091FF" :h="20" :stroke="8" />
        </div>

        <div class="dashboard-infos">
            <span
                v-if="!loading && groupIconTooltip"
                class="icon-group-tooltip"
            >
                <em :class="groupIconTooltip" />

                <span
                    class="tooltip"
                >
                    {{ infos }}
                </span>
            </span>

            <div class="user-infos">
                <div class="icon-name">
                    <span class="icon">
                        <em :class="groupIcon" />
                    </span>

                    <span class="name">{{ nameActionCard }}</span>
                </div>

                <div class="value">{{ valueResource }}</div>
            </div>

            <div class="positive-negative-variation">
                <span
                    class="variation"
                    :class="{ 'variation-negative': negativeVariation }"
                >
					{{ formattedVariation }}
				</span>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

	export default {
		name: 'dashboard-users-card',

		components: {
			uiLoadIndicator
		},

		props: {
			groupIcon: {
				type: String,
				required: false,
				default: ''
			},
			nameActionCard: {
				type: String,
				required: false,
				default: ''
			},
			valueResource: {
				type: [String, Number],
				required: false,
				default: ''
			},
			variation: {
				type: [String, Number],
				required: false,
				default: ''
			},
			loading: {
				type: Boolean,
				required: false,
				default: true
			},
			/**
			 * Utilize para adicionar um icone para o tooltip do card
			 */
			groupIconTooltip: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Informações acerca dos dados mostrados no card
			 */
			infos: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Define se a variação do card é positiva ou negativa
			 */
			negativeVariation: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		computed: {
			formattedVariation() {
				if (this.variation === undefined || this.variation === null || this.variation === '') {
					return '0%';
				}

				// Substituir vírgulas por pontos para tratar decimais corretamente
				const variationValue = Number(this.variation.toString().replace(',', '.'));

				if (isNaN(variationValue)) {
					return '0%';
				}

				// Formatar de volta para o formato com vírgulas para exibição
				const formattedValue = variationValue.toFixed(2).toString().replace('.', ',');

				// Retornar a formatação correta com o sinal + ou -
				return variationValue > 0 ? `+${formattedValue}%` : `${formattedValue}%`;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>